export function setPtfsConfies (state, candidats) {
  state.candidats = candidats
}

export function setFormFields (state, formFields) {
  state.formFields = formFields
}

export function setFilters (state, filters) {
  state.filters = filters.map(filter => ({
    ...filter, value: filter.value ? filter.value : null
  }))
}

export function setPagination (state, pagination) {
  state.pagination = pagination
}

export function setCurrentPtfConfie (state, PtfConfie) {
  state.currentPtfConfie = PtfConfie
}

export function setSessionStage (state, sessionStage) {
  state.sessionStage = sessionStage
}
